module.exports = __webpack_public_path__ + "img/10.af90d3f7.webp";